import { render, staticRenderFns } from "./AxisDiskStatusView.vue?vue&type=template&id=0e6f279c&scoped=true"
import script from "./AxisDiskStatusView.vue?vue&type=script&lang=js"
export * from "./AxisDiskStatusView.vue?vue&type=script&lang=js"
import style0 from "./AxisDiskStatusView.vue?vue&type=style&index=0&id=0e6f279c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6f279c",
  null
  
)

export default component.exports